import { css } from "@emotion/react"
import { PHOTO_RESOURCE_BASE_URL } from "config"
import { useInView } from "react-intersection-observer"
import { BREAK_POINT_PHONE_TAB } from "style"
import { Photo } from "type"

type Props = {
  photo: Photo
}

export const ArticleVideoItem = (props: Props)=>{
  const { ref } = useInView({
    onChange: (inView, entry) =>{
      const video = entry.target as HTMLVideoElement
      if (inView){
        video.play()
      }else{
        video.pause()
      }
    }
  })

  return(
    <div css={containerCss}>
      <video
        autoPlay={false}
        crossOrigin="anonymous"
        css={videoCss}
        playsInline
        ref={ref}
        muted
        loop
        preload="none"
      >
        <source src={PHOTO_RESOURCE_BASE_URL+'/'+props.photo.filename} type="video/mp4" />
        <source src={PHOTO_RESOURCE_BASE_URL+'/'+props.photo.filename} type="video/mp4" />
      </video>
    </div>
  )
}

const containerCss=css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px) {
    height: 700px;
  }
  overflow: hidden;
`

const videoCss = css`
  max-width: 100%;
  max-height: 350px;
  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px){
    max-height: 700px;
  }
  object-fit: cover;
  display: block;
  margin: 0;
`